import { createContext, useContext } from "react";

export function createSafeContext<ContextType>() {
  const safeContext = createContext<ContextType | undefined>(undefined);
  function useSafeContext() {
    const context = useContext(safeContext);

    if (!context)
      throw new Error("useSafeContext must be inside a Provider with a value");
    return context;
  }
  return [useSafeContext, safeContext] as const;
}
